class CurrencySelector extends HTMLElement {
  constructor() {
    super();
    this.currencySelector = this.querySelector(".currency-selector-dropdown");
    this.currencyFlags = this.querySelector(".currency-flags");
    this.init();
    this.currencySelector.addEventListener(
      "change",
      this.currencySelectorChangeHandler.bind(this)
    );
  }

  currencySelectorChangeHandler(event) {
    const value = event.target.value;
    this.hideFlags();
    this.showFlag(value);
    this.setShopCurrency(value);
  }

  init() {
    const urlObj = new URL(window.location.href);
    const urlCurrency = urlObj.searchParams.get("currency");
    const dropdownCurrency = this.currencySelector.value;

    if (urlCurrency) this.setInputCurrency(urlCurrency);
    this.showFlag(urlCurrency || dropdownCurrency);
  }

  setShopCurrency(currency) {
    const newURL = new URL(window.location.href);
    newURL.searchParams.set("currency", currency);
    window.location.href = newURL;
  }

  setInputCurrency(code) {
    this.currencySelector.value = code;
  }

  showFlag(code) {
    if (!code) return;
    const element = this.currencyFlags.querySelector(
      `[data-currency-code="${code}"]`
    );
    if (!element) return;
    element.dataset.flagVisible = true;
  }

  hideFlags() {
    this.currencyFlags
      .querySelectorAll(".flag")
      .forEach((el) => (el.dataset.flagVisible = false));
  }
}

customElements.define("currency-selector", CurrencySelector);
